/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { Form, Input } from 'antd'
import classnames from 'classnames'
import { DEFAULT_INPUT_LENGTH, LABEL_ALIGN_TYPE } from '../form.constants'
import { formRules, Validator } from '../form.utils'
import '../form.scss'
import InfoToolTipLabel from '../infotooltip-label/infotooltip-label'

export interface InputTextProps {
  maxLength?: number
  min?: {
    value: number
    message: string
  }
  max?: {
    value: number
    message: string
  }
  isAllowClear?: boolean
  isDisabled?: boolean
  label?: string | any
  name?: string | any
  isRequired?: boolean
  labelAlign?: keyof typeof LABEL_ALIGN_TYPE
  pattern?: RegExp
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
  inputContainerStyle?: string
  validateTrigger?: string | string[]
  validator?: Validator
  patternMessage?: string
  prefix?: React.ReactNode
  placeholder?: string
  value?: string | ReadonlyArray<string> | number | undefined
  isURL?: boolean
  isEmail?: boolean
  innerRef?: any
  htmlLabel?: string
  infoText?: string
}

const InputText: React.FC<InputTextProps> = (props: InputTextProps) => {
  const {
    min,
    max,
    label,
    name,
    labelAlign,
    isRequired,
    validator,
    onChange,
    className,
    pattern,
    patternMessage,
    isDisabled,
    isAllowClear,
    maxLength,
    validateTrigger,
    prefix,
    value,
    inputContainerStyle,
    isURL = false,
    isEmail = false,
    innerRef,
    htmlLabel,
    infoText,
  } = props

  return (
    <>
      <label htmlFor={htmlLabel ? htmlLabel : label}>
        <InfoToolTipLabel label={label} infoText={infoText} />
      </label>
      <Form.Item
        label={label}
        name={name}
        labelAlign={labelAlign}
        validateTrigger={validateTrigger}
        className={classnames('block', className)}
        rules={formRules(
          label,
          isRequired,
          validator,
          pattern,
          patternMessage,
          min,
          max,
          isURL,
          isEmail
        )}
        validateFirst={true}
      >
        <Input
          aria-label={label}
          className={classnames('form-item-input-width', inputContainerStyle)}
          disabled={isDisabled}
          id={name}
          onChange={onChange}
          allowClear={isAllowClear}
          maxLength={maxLength || DEFAULT_INPUT_LENGTH}
          prefix={prefix}
          value={value}
          type={isEmail ? 'email' : 'text'}
          ref={innerRef}
        />
      </Form.Item>
    </>
  )
}

export default InputText
